(function () {
  const TILE_PROVIDERS = {
    positron: {
      url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: 'abcd',
      maxZoom: 19,
    },
    voyager: {
      url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: 'abcd',
      maxZoom: 19,
    },
    dark: {
      url: 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: 'abcd',
      maxZoom: 19,
    },
    osm: {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 19,
    },
  };

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeWebsite(raw) {
    if (!raw) return null;
    const trimmed = String(raw).trim();
    if (!trimmed) return null;
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    return 'https://' + trimmed;
  }

  // Several distributor entries share identical or near-identical
  // coordinates because the metaobject only has a single HQ address
  // (e.g. all Loxo per-country entries point to Dossenheim, both Hong
  // Kong entries share the same building). When clustering disables on
  // zoom-in, those overlapping pins collapse visually to one. We spread
  // duplicates around a small ring so each marker is clickable.
  function spreadDuplicateCoords(distributors) {
    const radius = 0.45; // degrees, ~50km — visible at country zoom
    const groups = new Map();
    distributors.forEach(function (d, idx) {
      const key = parseFloat(d.lat).toFixed(3) + ',' + parseFloat(d.lng).toFixed(3);
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(idx);
    });
    groups.forEach(function (indices) {
      if (indices.length < 2) return;
      indices.forEach(function (idx, i) {
        const angle = (2 * Math.PI * i) / indices.length;
        const baseLat = parseFloat(distributors[idx].lat);
        const baseLng = parseFloat(distributors[idx].lng);
        // Scale longitude offset by 1/cos(lat) so the visual spread is
        // roughly circular rather than squashed near the equator.
        const lngScale = 1 / Math.max(0.1, Math.cos((baseLat * Math.PI) / 180));
        distributors[idx].lat = baseLat + radius * Math.sin(angle);
        distributors[idx].lng = baseLng + radius * Math.cos(angle) * lngScale;
      });
    });
    return distributors;
  }

  function buildPopupHtml(d) {
    const parts = [];
    parts.push('<div class="ir-dist-map-popup">');
    if (d.company) {
      parts.push('<h4>' + escapeHtml(d.company) + '</h4>');
    }
    if (d.country) {
      parts.push('<div class="ir-dist-map-popup__country">' + escapeHtml(d.country) + '</div>');
    }
    if (d.address) {
      parts.push('<p>' + escapeHtml(d.address) + '</p>');
    }
    if (d.telephone) {
      parts.push('<p><a href="tel:' + escapeHtml(d.telephone.replace(/\s+/g, '')) + '">' + escapeHtml(d.telephone) + '</a></p>');
    }
    if (d.email) {
      parts.push('<p><a href="mailto:' + escapeHtml(d.email) + '">' + escapeHtml(d.email) + '</a></p>');
    }
    const site = normalizeWebsite(d.website);
    if (site) {
      parts.push('<p><a href="' + escapeHtml(site) + '" target="_blank" rel="noopener">' + escapeHtml(d.website) + '</a></p>');
    }
    parts.push('</div>');
    return parts.join('');
  }

  function initMap(rootEl) {
    if (rootEl.dataset.mapInitialized === 'true') return;
    rootEl.dataset.mapInitialized = 'true';

    const sectionId = rootEl.id.replace('DistributorsMapHero--', '');
    const mapEl = document.getElementById('DistributorsMap--' + sectionId);
    const dataEl = document.getElementById('DistributorsMapData--' + sectionId);
    if (!mapEl || !dataEl) return;

    let distributors = [];
    try {
      distributors = JSON.parse(dataEl.textContent || '[]');
    } catch (err) {
      console.error('[ir-distributors-map] failed to parse data', err);
      return;
    }

    distributors = spreadDuplicateCoords(distributors);

    const providerKey = rootEl.dataset.tileProvider || 'positron';
    const provider = TILE_PROVIDERS[providerKey] || TILE_PROVIDERS.positron;
    const centerLat = parseFloat(rootEl.dataset.centerLat) || 20;
    const centerLng = parseFloat(rootEl.dataset.centerLng) || 10;
    const zoom = parseInt(rootEl.dataset.zoom, 10) || 2;
    const useCluster = rootEl.dataset.cluster === 'true';
    const clusterRadius = parseInt(rootEl.dataset.clusterRadius, 10) || 20;
    const disableClusterAtZoom = parseInt(rootEl.dataset.disableClusterAtZoom, 10) || 4;
    const headerOffset = parseInt(rootEl.dataset.headerOffset, 10) || 100;

    const map = L.map(mapEl, {
      center: [centerLat, centerLng],
      zoom: zoom,
      worldCopyJump: true,
      scrollWheelZoom: true,
      zoomControl: true,
    });

    L.tileLayer(provider.url, {
      attribution: provider.attribution,
      subdomains: provider.subdomains || 'abc',
      maxZoom: provider.maxZoom,
    }).addTo(map);

    let layer;
    if (useCluster && typeof L.markerClusterGroup === 'function') {
      layer = L.markerClusterGroup({
        showCoverageOnHover: false,
        spiderfyOnMaxZoom: true,
        zoomToBoundsOnClick: true,
        maxClusterRadius: clusterRadius,
        disableClusteringAtZoom: disableClusterAtZoom,
      });
    } else {
      layer = L.layerGroup();
    }

    // Keep popups from opening behind the sticky site header by padding
    // the auto-pan target away from the top of the viewport.
    const popupOptions = {
      maxWidth: 280,
      autoPanPaddingTopLeft: L.point(20, headerOffset),
      autoPanPaddingBottomRight: L.point(20, 20),
    };

    distributors.forEach(function (d) {
      const lat = parseFloat(d.lat);
      const lng = parseFloat(d.lng);
      if (!isFinite(lat) || !isFinite(lng)) return;
      const marker = L.marker([lat, lng], {
        title: d.company || d.country || '',
      });
      marker.bindPopup(buildPopupHtml(d), popupOptions);
      layer.addLayer(marker);
    });

    map.addLayer(layer);

    // Invalidate size after layout settles (fonts, animations).
    setTimeout(function () {
      map.invalidateSize();
    }, 300);

    // Re-invalidate on window resize for responsive height changes.
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        map.invalidateSize();
      }, 150);
    });
  }

  function bootAll() {
    if (typeof L === 'undefined') return false;
    const roots = document.querySelectorAll('.ir-dist-map-section');
    roots.forEach(initMap);
    return true;
  }

  function waitForLeaflet() {
    if (bootAll()) return;
    const interval = setInterval(function () {
      if (bootAll()) clearInterval(interval);
    }, 100);
    setTimeout(function () {
      clearInterval(interval);
    }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForLeaflet);
  } else {
    waitForLeaflet();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector) {
      const root = e.target.querySelector('.ir-dist-map-section');
      if (root) waitForLeaflet();
    }
  });
})();
